module.exports = __webpack_public_path__ + "static/media/wb.19be3bbd.png";